import React, { useId, useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useTranslation } from 'react-i18next';

export default function PrivateProfileValue({ label, value }) {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const id = useId();
    return <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
        <Typography variant="body2" sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>
            {label}: <span id={id} style={{ userSelect: 'none', WebkitUserSelect: 'none', WebkitTouchCallout: 'none' }}
                onCopy={event => event.preventDefault()}>{visible ? value : '***'}</span>
        </Typography>
        <IconButton size="small" type="button" aria-controls={id} aria-expanded={visible}
            aria-label={`${t(visible ? 'auth.hideDetail' : 'auth.showDetail')}: ${label}`}
            onClick={() => setVisible(current => !current)}>
            {visible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
        </IconButton>
    </Box>;
}
